import router from './index'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式

router.beforeEach((to,from,next)=>{
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
  if(to.path.indexOf("/admin")==-1||to.path=='/admin/login'){
    next()
  }else{
    NProgress.start() 
    if(getToken()){//是否获取到jwt令牌
      if(to.path == '/admin/login' || to.path == '/admin/'){//是否目标地址是login
         next({path:"/admin/home",replace:true})
      }else{
        next()
      }
    }else{//登录认证失败  
        next("/admin/login").then(()=>{
          Message.error("请先登录")
          window.location.reload()
        })

    }
  }
})
router.afterEach(()=>{
  NProgress.done()
})
